module.exports = __webpack_public_path__ + "img/event.c547fdd9.svg";